import { Navigate } from 'react-router-dom';
import NoMatch from '@App/pages/NoMatch/NoMatch';
import Map from '@App/pages/Map/Map';

const routes = [
  { 
    path: '/', 
    element: <Navigate to="/michelin" replace />,
  },
  {
    name: 'MichelinMap',
    path: '/michelin',
    element: <Map mapStyle="michelin" />,
  },
  {
    name: 'MercatorMap', 
    path: '/mercator', 
    element: <Map mapStyle="mercator" />,
  },
  {
    name: 'ElectroMap', 
    path: '/electro', 
    element: <Map mapStyle="electro" />,
  },
  {
    name: 'Page Not Found', 
    path: '*', 
    element: <NoMatch />,
  },
];

export default routes;
